// Remembers which filter trigger button was clicked last, so FilterModal can open
// as a dropdown anchored under that button (like the commodity selector) without
// every chart having to pass a ref. FilterDropdown registers itself on click;
// FilterModal reads (and clears) the anchor when it opens. If no anchor is
// registered or it is detached from the DOM, FilterModal falls back to the
// centered modal.

let lastAnchor = null;

export const registerFilterAnchor = (el) => {
  lastAnchor = el || null;
};

export const takeFilterAnchor = () => {
  const el = lastAnchor;
  lastAnchor = null;
  return el && typeof document !== 'undefined' && document.contains(el) ? el : null;
};
